export default "__VITE_ASSET__BSgP1lmP__"